// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledTableResponsiveContainer = styled("div")`
	display: flex;
	${({ scrollable }) =>
		scrollable &&
		css`
			overflow-y: overlay;
			overflow-x: auto;
		`}
`;

// #####################################################
